// src/pages/CustomersPage.jsx
import React, { useState, useEffect, } from 'react';
import { useNavigate } from 'react-router-dom';

const CustomersPage = () => {
  const [customers, setCustomers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/store#customers")
  }, []);





};

export default CustomersPage;